import React from "react";
import { FaChevronRight, FaUsers } from "react-icons/fa";
import ChildEmptyState from "../../shared/components/ChildEmptyState";

const initialsFor = (name) =>
  String(name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("") || "?";

export default function ChildFamilySection({
  id,
  families = [],
  title,
  emptyTitle,
  selectedFamilyId,
  onSelectFamily,
  onOpenFamily,
  viewLabel,
  linkedLabel,
}) {
  return (
    <section id={id} className="rounded-[20px] border border-slate-200/80 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-white/5">
      <div className="mb-4 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 dark:bg-indigo-400/15 dark:text-indigo-200">
          <FaUsers aria-hidden="true" />
        </span>
        <h3 className="text-xl font-bold text-slate-950 dark:text-white">{title}</h3>
      </div>
      {families.length ? (
        <div className="space-y-3">
          {families.map((family) => {
            const selected = String(selectedFamilyId || "") === String(family.id);
            return (
            <div
              key={family.id}
              className={`flex flex-col gap-3 rounded-[18px] border p-4 transition sm:flex-row sm:items-center sm:justify-between ${
                selected
                  ? "border-indigo-400 bg-indigo-50/90 shadow-sm shadow-indigo-100 ring-2 ring-indigo-200/70 dark:border-indigo-300/60 dark:bg-indigo-400/15 dark:shadow-none dark:ring-indigo-300/20"
                  : "border-sky-100 bg-sky-50/70 hover:border-sky-200 hover:bg-sky-50 dark:border-sky-400/20 dark:bg-sky-400/10 dark:hover:bg-sky-400/15"
              }`}
            >
              <button
                type="button"
                onClick={() => onSelectFamily?.(family)}
                aria-pressed={selected}
                className="flex min-w-0 flex-1 items-center gap-4 rounded-2xl text-left transition hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:hover:text-indigo-200"
              >
                <span
                  className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-base font-bold ${
                    selected
                      ? "bg-indigo-100 text-indigo-700 dark:bg-indigo-300/20 dark:text-indigo-100"
                      : "bg-sky-100 text-sky-700 dark:bg-sky-300/15 dark:text-sky-100"
                  }`}
                >
                  {initialsFor(family.familyName)}
                </span>
                <div className="min-w-0">
                  <p className="break-words text-base font-bold text-slate-950 dark:text-white">{family.familyName}</p>
                  <p className="text-sm text-slate-500 dark:text-slate-300">{linkedLabel}</p>
                </div>
              </button>
              <button
                type="button"
                onClick={() => onOpenFamily(family)}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-sky-200 bg-white px-4 py-2 text-sm font-semibold text-indigo-700 shadow-sm transition hover:-translate-y-0.5 hover:text-indigo-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 motion-reduce:hover:translate-y-0 dark:border-white/10 dark:bg-white/10 dark:text-indigo-200"
              >
                {viewLabel}
                <FaChevronRight aria-hidden="true" />
              </button>
            </div>
          );
          })}
        </div>
      ) : (
        <ChildEmptyState title={emptyTitle} />
      )}
    </section>
  );
}
